import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function TermsModal({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-26">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-27">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-28">
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-29">
              <XIcon className="w-5 h-5" data-id="element-30" />
            </button>
            <h3 className="text-2xl font-display font-bold text-white mb-6" data-id="element-31">
              Términos y Condiciones
            </h3>
            <div className="text-gray-400 text-sm leading-relaxed space-y-4" data-id="element-32">
              <p data-id="element-33">
                <strong className="text-gray-300" data-id="element-34">
                  1. Aceptación de los Términos.
                </strong>{' '}
                Al adquirir y descargar el producto digital "Generación Wealth",
                usted acepta estos términos y condiciones en su totalidad. Si no
                está de acuerdo, no realice la compra.
              </p>
              <p data-id="element-35">
                <strong className="text-gray-300" data-id="element-36">2. Producto Digital.</strong>{' '}
                "Generación Wealth" es un producto digital informativo y
                educativo que se entrega en formato PDF y audio. No constituye
                asesoría financiera, legal ni fiscal personalizada.
              </p>
              <p data-id="element-37">
                <strong className="text-gray-300" data-id="element-38">3. Uso Personal.</strong> El
                contenido adquirido es para uso personal y no comercial. Queda
                prohibida la reproducción, distribución, reventa o modificación
                del material sin autorización expresa por escrito.
              </p>
              <p data-id="element-39">
                <strong className="text-gray-300" data-id="element-40">
                  4. Propiedad Intelectual.
                </strong>{' '}
                Todo el contenido, incluyendo textos, gráficos, audio y diseño,
                es propiedad exclusiva de Generación Wealth y está protegido por
                las leyes de derechos de autor aplicables.
              </p>
              <p data-id="element-41">
                <strong className="text-gray-300" data-id="element-42">
                  5. Política de Reembolso.
                </strong>{' '}
                Debido a la naturaleza digital del producto, todas las ventas
                son finales. No se ofrecen reembolsos una vez completada la
                descarga. Si experimenta problemas técnicos con la descarga,
                contáctenos para asistencia.
              </p>
              <p data-id="element-43">
                <strong className="text-gray-300" data-id="element-44">
                  6. Descargo de Responsabilidad.
                </strong>{' '}
                La información proporcionada tiene fines educativos únicamente.
                Los resultados pueden variar según las circunstancias
                individuales. No garantizamos resultados financieros
                específicos. Consulte con un profesional financiero certificado
                antes de tomar decisiones de inversión.
              </p>
              <p data-id="element-45">
                <strong className="text-gray-300" data-id="element-46">
                  7. Limitación de Responsabilidad.
                </strong>{' '}
                Generación Wealth no será responsable por daños directos,
                indirectos, incidentales o consecuentes derivados del uso o la
                imposibilidad de uso del producto.
              </p>
              <p data-id="element-47">
                <strong className="text-gray-300" data-id="element-48">8. Privacidad.</strong>{' '}
                Respetamos su privacidad. La información personal recopilada
                durante la compra se utiliza únicamente para procesar su pedido
                y no será compartida con terceros sin su consentimiento.
              </p>
              <p data-id="element-49">
                <strong className="text-gray-300" data-id="element-50">9. Modificaciones.</strong>{' '}
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Las modificaciones entrarán en vigor
                inmediatamente después de su publicación.
              </p>
              <p data-id="element-51">
                <strong className="text-gray-300" data-id="element-52">10. Ley Aplicable.</strong>{' '}
                Estos términos se rigen por las leyes de los Estados Unidos de
                América. Cualquier disputa será resuelta en los tribunales
                competentes.
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
function PrivacyModal({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-53">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-54">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-55">
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-56">
              <XIcon className="w-5 h-5" data-id="element-57" />
            </button>
            <h3 className="text-2xl font-display font-bold text-white mb-6" data-id="element-58">
              Política de Privacidad
            </h3>
            <div className="text-gray-400 text-sm leading-relaxed space-y-4" data-id="element-59">
              <p data-id="element-60">
                <strong className="text-gray-300" data-id="element-61">
                  Información que recopilamos.
                </strong>{' '}
                Recopilamos únicamente la información necesaria para procesar su
                compra: nombre, dirección de correo electrónico e información de
                pago.
              </p>
              <p data-id="element-62">
                <strong className="text-gray-300" data-id="element-63">
                  Uso de la información.
                </strong>{' '}
                Su información se utiliza exclusivamente para: procesar y
                entregar su compra, enviar confirmación de pedido y proporcionar
                soporte al cliente si lo solicita.
              </p>
              <p data-id="element-64">
                <strong className="text-gray-300" data-id="element-65">Protección de datos.</strong>{' '}
                Utilizamos medidas de seguridad estándar de la industria para
                proteger su información personal. Los pagos son procesados por
                plataformas de pago seguras y certificadas.
              </p>
              <p data-id="element-66">
                <strong className="text-gray-300" data-id="element-67">
                  No compartimos su información.
                </strong>{' '}
                No vendemos, alquilamos ni compartimos su información personal
                con terceros, excepto cuando sea necesario para procesar su
                pago.
              </p>
              <p data-id="element-68">
                <strong className="text-gray-300" data-id="element-69">Contacto.</strong> Para
                cualquier consulta sobre privacidad, puede contactarnos a través
                de nuestros canales oficiales.
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="py-10 px-6 border-t border-white/5 bg-dark" data-id="element-70">
        <div className="max-w-4xl mx-auto" data-id="element-71">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-72">
            <p className="text-gray-500 text-sm" data-id="element-73">
              © {new Date().getFullYear()} Generación Wealth. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-74">
              <button onClick={() => setShowTerms(true)} className="text-gray-500 text-sm hover:text-gold-400 transition-colors" data-id="element-75">
                Términos y Condiciones
              </button>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-500 text-sm hover:text-gold-400 transition-colors" data-id="element-76">
                Política de Privacidad
              </button>
            </div>
          </div>
          <p className="text-gray-600 text-xs text-center mt-6" data-id="element-77">
            Este producto es informativo y educativo. No constituye asesoría
            financiera profesional. Consulte con un profesional certificado
            antes de tomar decisiones de inversión.
          </p>
        </div>
      </footer>

      <TermsModal open={showTerms} onClose={() => setShowTerms(false)} data-id="element-78" />
      <PrivacyModal open={showPrivacy} onClose={() => setShowPrivacy(false)} data-id="element-79" />
    </>;
}